interface Props {
  passwordValue: string;
  showPasswordCriteria: boolean;
}

export const PasswordCriteria = (props: Props) => {
  return (
    <div className={`form__password-criteria font-h6-regular ${props.showPasswordCriteria ? 'show' : ''}`}>
      <h5 className='font-h6-bold'>Password must contain:</h5>
      <div className='form__password-criteria__item'>
        <span className={`form__password-criteria__item__ellipse ${props.passwordValue.length >= 8 && 'bg-green-100'}`}></span>
        <span>at least 8 characters</span>
      </div>
      <div className='form__password-criteria__item'>
        <div className={`form__password-criteria__item__ellipse ${/[a-z]/.test(props.passwordValue) && 'bg-green-100'}`}></div>
        <span>lower-case</span>
      </div>
      <div className='form__password-criteria__item'>
        <div className={`form__password-criteria__item__ellipse ${/[A-Z]/.test(props.passwordValue) && 'bg-green-100'}`}></div>
        <span>upper-case</span>
      </div>
      <div className='form__password-criteria__item'>
        <div className={`form__password-criteria__item__ellipse ${/\d/.test(props.passwordValue) && 'bg-green-100'}`}></div>
        <span>number</span>
      </div>
      <div className='form__password-criteria__item'>
        <div className={`form__password-criteria__item__ellipse ${/[^a-zA-Z0-9]/.test(props.passwordValue) && 'bg-green-100'}`}></div>
        <span>symbol</span>
      </div>
    </div>
  );
};
